import { useMemo } from "react";
import { useStandardProduct } from "app/hooks/shared/standard-product/useStandardProduct";
import { OptionModalState } from "../option-modal";
import { StandardOptionsGeneralTemplate } from "./components/StandardOptionsGeneralTemplate";
import {
  glassMetaData,
  paintMetaData,
  toolsMetaData,
  voucherMetaData,
  zenEnZachtMetaData,
} from "shared/utils/usps";
import { AcousticPanel } from "./components/AcousticPanel";

interface Props {
  setOptionModalState: (state: OptionModalState) => void;
}

const StandardProductOptions = ({ setOptionModalState }: Props) => {
  const { store } = useStandardProduct();

  const selectedCategory = useMemo(
    () => store.selectedStandardProductCategory,
    [store.selectedStandardProductCategory]
  );

  if (selectedCategory === undefined) {
    return null;
  }
  switch (selectedCategory.code) {
    case "gereedschap":
      return (
        <StandardOptionsGeneralTemplate
          setOptionModalState={setOptionModalState}
          additionalData={toolsMetaData}
          selectedCategory={selectedCategory}
        />
      );
    case "glasreiniger":
      return (
        <StandardOptionsGeneralTemplate
          setOptionModalState={setOptionModalState}
          additionalData={glassMetaData}
          selectedCategory={selectedCategory}
        />
      );
    case "verfset":
      return (
        <StandardOptionsGeneralTemplate
          setOptionModalState={setOptionModalState}
          additionalData={paintMetaData}
          selectedCategory={selectedCategory}
        />
      );
    case "cadeaukaart":
      return (
        <StandardOptionsGeneralTemplate
          setOptionModalState={setOptionModalState}
          additionalData={voucherMetaData}
          selectedCategory={selectedCategory}
        />
      );

    default:
      return (
        <AcousticPanel
          setOptionModalState={setOptionModalState}
          additionalData={zenEnZachtMetaData}
          selectedCategory={selectedCategory}
        />
      );
  }
};
export default StandardProductOptions;
